/*jshint esversion: 6 */
import http from './http'

export default {
    get : function(){
        return http.get('includes/php/ajax_load.php?tipo=dadosUsuario');
    },

    verifyLogin : function(user){
        user["tipo"] = "existeLogin";
        return http.post('includes/php/ajax_load.php', {
            data : user
        })
    },

    insert : function(user){
        user["inserir-usuario"] = true;
        return http.post('includes/php/ajax_insert.php', {
            data: user
        })
    },

    update : function(user){
        user["atualizar-perfil"] = true;
        return http.post('includes/php/ajax_update.php', {
            data: user
        })
    },

    updatePassword : function(user) {
        user["atualizar-senha"] = true;
        return http.post('includes/php/ajax_update.php', {
            data : user
        });
    },

    resetPassword : function(login) {
        return http.post('includes/php/ajax_update.php', {
            data : {
                "reset-senha" : true,
                "login" : login
            }
        });
    },

    activateUser : function(login, active) {
        return http.post('includes/php/ajax_update.php', {
            data : {
                "ativar-usuario" : true,
                "login" : login,
                "ativo" : active
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/js/services/user.js